import { render, staticRenderFns } from "./barContent.vue?vue&type=template&id=c2831a48&scoped=true&"
import script from "./barContent.vue?vue&type=script&lang=js&"
export * from "./barContent.vue?vue&type=script&lang=js&"
import style0 from "./barContent.vue?vue&type=style&index=0&id=c2831a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2831a48",
  null
  
)

component.options.__file = "barContent.vue"
export default component.exports